import { HistoryRuleAction } from '../model/history-rule-action.enum';
import { HistoryRuleRecord } from '../model/history-rule-record';
import { HistoryModuleResponse, HistoryRuleResponse } from '../model/history-rule-response';
import { splitDateTime } from './date-time-utils';

export const ACTION_MAP: Record<string, HistoryRuleAction> = {
  create: HistoryRuleAction.CREATE,
  update: HistoryRuleAction.UPDATE,
  delete: HistoryRuleAction.DELETE
};

export const mapActionToEnum = (action: string): HistoryRuleAction =>
  ACTION_MAP[action?.toLowerCase()] ?? HistoryRuleAction.UPDATE;

export const convertHistoryRuleResponseToHistoryRuleUIRecords = (
  response: HistoryRuleResponse
): HistoryRuleRecord[] => {
  if (Array.isArray(response?.history?.envelopes)) {
    return response.history.envelopes.map((envelope) => {
      const dateTime = envelope.date || '';
      const [datePart, timePart] = splitDateTime(dateTime);
      return {
        id: envelope.data?.rule?.id || '',
        date: datePart,
        action: mapActionToEnum(envelope.action || ''),
        user: envelope.lssInformation?.userId || '',
        time: timePart
      };
    });
  }
  return [];
};

export const convertModuleHistoryToRows = (response: HistoryModuleResponse): RuleHistoryRow[] => {
  if (!response?.history?.length) {
    return [];
  }

  return response.history.flatMap((historyRecord) =>
    historyRecord.envelopes.map((envelope) => {
      const dateTime = envelope.date || '';
      const [datePart, timePart] = splitDateTime(dateTime);

      return {
        ruleId: envelope.data?.rule?.id || '',
        ruleName: envelope.data?.rule?.name || '',
        action: mapActionToEnum(envelope.action || ''),
        date: datePart,
        time: timePart,
        user: envelope.lssInformation?.userId || ''
      };
    })
  );
};

export interface RuleHistoryRow {
  ruleId: string;
  ruleName: string;
  action: HistoryRuleAction;
  date: string;
  time: string;
  user: string;
}

export interface TimeRange {
  begin: string;
  end: string;
}
